/* @flow */
// typecheck: ignore file
import Button from 'components/Button.jsx';
import LayerTrigger from 'components/LayerTrigger.jsx';
import mountTymkPrompt from 'utils/mountTymkPrompt';
import React from 'react';
import cx from 'classnames';
import Text from 'components/Text.jsx';
import Timestamp from 'components/Timestamp.jsx';
import Tooltip from 'components/Tooltip.jsx';
import UniversalComposeHovercard from 'chat/components/UniversalComposeHovercard.jsx';
import User from 'entities/User';

type Props = {
  currentUser: User,
  hideAnnouncements?: ?bool,
  hideActivities?: ?bool,
  label?: any,
  onComposeSelection?: ?Function,
  className?: string,
};

export default class UniversalComposeButton extends React.Component {
  props: Props;

  static defaultProps = {
    label: 'New message',
  };

  renderButton() {
    const { currentUser, label, ...props } = this.props;

    return (
      <Button
        disabled={currentUser.isMuted()}
        data-test-selector="universial_compose_button"
        {...props}
        className={cx('UniversalComposeButton', this.props.className)}
        eventElementName="UniversalComposeButton">
        {label}
      </Button>
    );
  }

  renderEnabledButton() {
    const { currentUser, hideActivities, hideAnnouncements, onComposeSelection } = this.props;

    return (
      <LayerTrigger
        ref="activityLayer"
        trigger="click"
        layer={
          <UniversalComposeHovercard
            currentUser={currentUser}
            hideActivities={hideActivities}
            hideAnnouncements={hideAnnouncements}
            onMessageSent={() => { mountTymkPrompt(this, 'send_announcement'); }}
            onComposeSelection={onComposeSelection}
          />
        }
        placement="bottom"
        delayShow={400}>
        {this.renderButton()}
      </LayerTrigger>
    );
  }

  renderDisabledButton() {
    const { currentUser } = this.props;
    const timestamp = <Timestamp date={currentUser.getMutedUntil()} format="long" />;

    return (
      <LayerTrigger
        layer={
          <Tooltip>
            <Text align="center" element="div">
              Your messaging privileges have been temporarily suspended until {timestamp}.
            </Text>
          </Tooltip>
        }
        placement="bottom">
        {this.renderButton()}
      </LayerTrigger>
    );
  }

  render() {
    const { currentUser } = this.props;

    return currentUser.isMuted() ? this.renderDisabledButton() : this.renderEnabledButton();
  }
}



// WEBPACK FOOTER //
// ./src/chat/components/UniversalComposeButton.jsx